import EditIcon from '@mui/icons-material/Edit';
import { CardActionArea } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import React from 'react';
import Colors from '../colors';

const Row = styled(CardActionArea)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'left',
  justifyContent: 'left',
  padding: theme.spacing(2),
  backgroundColor: Colors.white,
  borderRadius: '8px',
  '&&': {
    fontFamily: 'Jost'
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: Colors.mediumGray,
  fontFamily: 'Jost',
  textTransform: 'uppercase',
}));

const MainText = styled(Typography)(({ theme }) => ({
  fontSize: '1.2rem',
  fontWeight: 'bold',
  fontFamily: 'Jost',
  display: 'block',
  wordBreak: 'break-word',
}));

const MainTextEmptyMsg = styled(Typography)(({ theme }) => ({
  fontSize: '1.2rem',
  fontWeight: 400,
  fontFamily: 'Jost',
  fontStyle: 'italic',
  textTransform: 'capitalize',
}));

const SubText = styled(Typography)(({ theme }) => ({
  fontSize: '0.95rem',
  color: `${Colors.gray}`,
  fontWeight: 'bold',
  fontFamily: 'Jost',
}));

const InfoRow = ({
  iconComponent,
  title,
  mainText = '',
  subText,
  isEditable,
  onClickHandler,
  icon,
  iconClickHandler
}) => {
  return (
    <Row onClick={isEditable ? onClickHandler : undefined}>
      <Box sx={{ color: 'black', marginRight: '5px' }}>
        {iconComponent}
      </Box>
      <Box>
        <Title>{title}</Title>
        {mainText.length === 0 ? (
          <MainTextEmptyMsg>Not specified</MainTextEmptyMsg>
        ) : (
          <MainText>{mainText}</MainText>
        )}
        <SubText>{subText}</SubText>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginLeft: 'auto' }}>
        {icon && (
          <Box sx={{ marginBottom: '10px' }} onClick={iconClickHandler}>
            {icon}
          </Box>
        )}
        {isEditable && (
          <Box>
            <EditIcon />
          </Box>
        )}
      </Box>
    </Row>
  );
};

export default InfoRow;
